import { Fragment, memo } from 'react';
import breastImg from '../../../../assets/images/breast.jpg';
import plusSignBreastImg from '../../../../assets/images/plusSignBreast.png';
import urinaryBladderInMalesImg from '../../../../assets/images/urinaryBladderInMales.png';
import ovaryImg from '../../../../assets/images/Ovary.png';
import humanUrinaryBladderImg from '../../../../assets/images/humanUrinaryBladder.png';
import {
  capitalizeFirstLetter,
  isExistAnyBreastData,
  lineHeightStyle,
  styledComponent,
} from '../../../../utils/helpers';
import CommonDeleteBtn from '../commonDeleteBtn';

const Gyne = ({
  selectedOnExamination,
  setSelectedOnExamination,
  prescriptionItems,
  isDelBtn = true,
}) => {
  let { gyneExamination } = selectedOnExamination || {};
  let { breastExamination } = selectedOnExamination || {};
  let { others } = selectedOnExamination || {};

  const deleteData = (itemName) => {
    const updatedBreastExamination = { ...breastExamination };

    switch (itemName) {
      case 'lump':
      case 'nippleArolaComplex':
      case 'axillaryLymphNode':
        updatedBreastExamination[itemName] = {
          left: false,
          right: false,
          both: false,
        };
        break;
      case 'lumpPosition':
      case 'nippleArolaComplexPosition':
      case 'axillaryLymphNodePosition':
        updatedBreastExamination[itemName] = {
          uoq: false,
          loq: false,
          uiq: false,
          liq: false,
        };
        break;
      case 'isBreastPicture':
      case 'showPlusSignBreast':
        updatedBreastExamination[itemName] = false;
        break;
      default:
        updatedBreastExamination[itemName] = '';
    }

    setSelectedOnExamination({
      ...selectedOnExamination,
      breastExamination: updatedBreastExamination,
    });
  };

  const clearData = (itemName) => {
    const updatedGyneExamination = { ...gyneExamination };

    switch (itemName) {
      case 'fm':
        updatedGyneExamination.fm = '';
        break;
      case 'fhs':
        updatedGyneExamination.fhsPresent = false;
        updatedGyneExamination.fhsAbsent = false;
        break;
      case 'show':
        updatedGyneExamination.showPresent = false;
        updatedGyneExamination.showAbsent = false;
        break;
      case 'cmt':
        updatedGyneExamination.cmtPresent = false;
        updatedGyneExamination.cmtAbsent = false;
        break;
      case 'discharge':
        updatedGyneExamination.dischargeYes = false;
        updatedGyneExamination.dischargeNo = false;
        break;
      case 'dischargeNote':
        updatedGyneExamination.dischargeNote = '';
        break;
      case 'paw':
        updatedGyneExamination.pawHealthy = false;
        updatedGyneExamination.pawInfected = false;
        break;
      case 'pawNote':
        updatedGyneExamination.pawNote = '';
        break;
      case 'bleeding':
        updatedGyneExamination.bleedingAbsent = false;
        updatedGyneExamination.bleedingPresent = false;
        break;
      default:
        updatedGyneExamination[itemName] = '';
    }

    setSelectedOnExamination({
      ...selectedOnExamination,
      gyneExamination: updatedGyneExamination,
    });
  };

  const clearOthers = (itemName) => {
    const imageFieldsArr = ['isUrinaryBladderInMale','isOvary','isHumanUrinaryBladder'];

    const updatedOthers = {
      ...others,
      [itemName]: imageFieldsArr.includes(itemName) ? false : '',
    };

    setSelectedOnExamination({
      ...selectedOnExamination,
      others: updatedOthers,
    });
  };

  const getData = (data) => {
    let result = [];
    for (let key in data) {
      if (data[key] === true) {
        result.push(key);
      }
    }
    return result;
  };

  const Title = styledComponent(
    prescriptionItems?.items?.['on-examination']?.itemStyle || {},
  );
  const Value = styledComponent(
    prescriptionItems?.items?.['on-examination']?.subItemStyle || {},
  );

  return (
    <div className="breast-exam-view">
      {(gyneExamination?.sfh ||
        gyneExamination?.fm ||
        gyneExamination?.fhsPresent ||
        gyneExamination?.fhsAbsent ||
        gyneExamination?.presentation) && (
        <div className="sub-title">
          <b>P/A/E (Pregnency)</b>
        </div>
      )}
      <ul style={lineHeightStyle('on-examination', prescriptionItems)}>
        {gyneExamination?.sfh && (
          <li>
            <span className="text-left pr-5">
              <Title>SFH:</Title>
              <Value> {gyneExamination?.sfh} Weeks</Value>
            </span>
            <CommonDeleteBtn
              action={clearData}
              itemName={'sfh'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {gyneExamination?.fm && (
          <li>
            <span className="text-left pr-5">
              <Title>FM:</Title>
              <Value> {gyneExamination?.fm}</Value>
            </span>
            <CommonDeleteBtn
              action={clearData}
              itemName={'fm'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {gyneExamination?.fhsPresent && (
          <li>
            <span className="text-left pr-5">
              <Title>FHS:</Title>
              <Value> Present</Value>
            </span>
            <CommonDeleteBtn
              action={clearData}
              itemName={'fhsPresent'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {gyneExamination?.fhsAbsent && (
          <li>
            <span className="text-left pr-5">
              <Title>FHS:</Title>
              <Value> Absent</Value>
            </span>
            <CommonDeleteBtn
              action={clearData}
              itemName={'fhsAbsent'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {gyneExamination?.presentation && (
          <li>
            <span className="text-left pr-5">
              <Title>Presentation:</Title>{' '}
              <Value>{gyneExamination?.presentation}</Value>
            </span>
            <CommonDeleteBtn
              action={clearData}
              itemName={'presentation'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
      </ul>
      {(gyneExamination?.os ||
        gyneExamination?.cervix ||
        gyneExamination?.effacement ||
        gyneExamination?.station ||
        gyneExamination?.mumbrance ||
        gyneExamination?.effacement ||
        gyneExamination?.showPresent ||
        gyneExamination?.showAbsent) && (
        <div className="sub-title">
          <b>P/V/E (Pregnency)</b>
        </div>
      )}
      <ul>
        {gyneExamination?.os && (
          <li>
            <span className="text-left pr-5">
              <Title>OS:</Title>
              <Value> {gyneExamination?.os}</Value>
            </span>
            <CommonDeleteBtn
              action={clearData}
              itemName={'os'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {gyneExamination?.cervix && (
          <li>
            <span className="text-left pr-5">
              <Title> Cervix:</Title>
              <Value> {gyneExamination?.cervix}</Value>
            </span>
            <CommonDeleteBtn
              action={clearData}
              itemName={'cervix'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {gyneExamination?.effacement && (
          <li>
            <span className="text-left pr-5">
              <Title>Effacement:</Title>
              <Value> {gyneExamination?.effacement}</Value>
            </span>
            <CommonDeleteBtn
              action={clearData}
              itemName={'effacement'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {gyneExamination?.station && (
          <li>
            <span className="text-left pr-5">
              <Title>Station:</Title>
              <Value> {gyneExamination?.station}</Value>
            </span>
            <CommonDeleteBtn
              action={clearData}
              itemName={'station'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {gyneExamination?.mumbrance && (
          <li>
            <span className="text-left pr-5">
              <Title>Mumbrance:</Title>{' '}
              <Value> {gyneExamination?.mumbrance}</Value>
            </span>
            <CommonDeleteBtn
              action={clearData}
              itemName={'mumbrance'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {gyneExamination?.showPresent && (
          <li>
            <span className="text-left pr-5">
              <Title>Show:</Title>
              <Value> Present</Value>
            </span>
            <CommonDeleteBtn
              action={clearData}
              itemName={'showPresent'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {gyneExamination?.showAbsent && (
          <li>
            <span className="text-left pr-5">
              <Title>Show:</Title>
              <Value> Absent</Value>
            </span>
            <CommonDeleteBtn
              action={clearData}
              itemName={'showAbsent'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
      </ul>
      {(gyneExamination?.nad ||
        gyneExamination?.nadNote ||
        gyneExamination?.uterus ||
        gyneExamination?.wkSize ||
        gyneExamination?.lump) && (
        <div className="sub-title">
          <b>P/A/E (Gynae)</b>
        </div>
      )}
      <ul>
        {gyneExamination?.nad && (
          <li>
            <span className="text-left pr-5">
              <Title>NAD:</Title>
              <Value> Yes</Value>
            </span>
            <CommonDeleteBtn
              action={clearData}
              itemName={'nad'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {gyneExamination?.nadNote && (
          <li>
            <span className="text-left pr-5">
              <Title>NAD Note:</Title>
              <Value> {gyneExamination?.nadNote}</Value>
            </span>
            <CommonDeleteBtn
              action={clearData}
              itemName={'nadNote'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {gyneExamination?.uterus && (
          <li>
            <span className="text-left pr-5">
              <Title>Uterus:</Title>
              <Value> {gyneExamination?.uterus}</Value>
            </span>
            <CommonDeleteBtn
              action={clearData}
              itemName={'uterus'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {gyneExamination?.wkSize && (
          <li>
            <span className="text-left pr-5">
              <Title>Size:</Title>
              <Value> {gyneExamination?.wkSize}</Value>
            </span>
            <CommonDeleteBtn
              action={clearData}
              itemName={'wkSize'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {gyneExamination?.lump && (
          <li>
            <span className="text-left pr-5">
              <Title>LUMP:</Title>
              <Value> {gyneExamination?.lump}</Value>
            </span>
            <CommonDeleteBtn
              action={clearData}
              itemName={'lump'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
      </ul>
      {(gyneExamination?.inspectionNad ||
        gyneExamination?.inspectionNadNote) && (
        <Fragment>
          <div className="sub-title">
            <b>P/V/E (Gynae)</b>
          </div>
          <ul>
            {gyneExamination?.inspectionNad && (
              <li>
                <span className="text-left pr-5">
                  <Title>Inspection:</Title>
                  <Value> {gyneExamination?.inspectionNad && 'NAD'}</Value>
                </span>
                <CommonDeleteBtn
                  action={clearData}
                  itemName={'inspectionNad'}
                  isDelBtn={isDelBtn}
                />
              </li>
            )}
            {gyneExamination?.inspectionNadNote && (
              <li>
                <span className="text-left pr-5">
                  <Title>Note:</Title>
                  <Value> {gyneExamination?.inspectionNadNote}</Value>
                </span>
                <CommonDeleteBtn
                  action={clearData}
                  itemName={'inspectionNadNote'}
                  isDelBtn={isDelBtn}
                />
              </li>
            )}
          </ul>
        </Fragment>
      )}
      {(gyneExamination?.pseCervix ||
        gyneExamination?.dischargeNote ||
        gyneExamination?.dischargeYes ||
        gyneExamination?.dischargeNo) && (
        <Fragment>
          <div className="sub-title">
            <b>Per Speculum Examination (P/S/E)</b>
          </div>
          <ul>
            {gyneExamination?.pseCervix && (
              <li>
                <span className="text-left pr-5">
                  <Title>Cervix:</Title>
                  <Value> {gyneExamination?.pseCervix}</Value>
                </span>
                <CommonDeleteBtn
                  action={clearData}
                  itemName={'pseCervix'}
                  isDelBtn={isDelBtn}
                />
              </li>
            )}
            {(gyneExamination?.dischargeYes ||
              gyneExamination?.dischargeNo) && (
              <li>
                <span className="text-left pr-5">
                  <Title>Discharge:</Title>
                  <Value>
                    {' '}
                    {gyneExamination?.dischargeYes ? 'Yes' : ''}{' '}
                    {gyneExamination?.dischargeNo ? 'No' : ''}
                  </Value>
                </span>
                <CommonDeleteBtn
                  action={clearData}
                  itemName={'discharge'}
                  isDelBtn={isDelBtn}
                />
              </li>
            )}
            {gyneExamination?.dischargeNote && (
              <li>
                <span className="text-left pr-5">
                  <Title>Discharge Note:</Title>
                  <Value> {gyneExamination?.dischargeNote}</Value>
                </span>
                <CommonDeleteBtn
                  action={clearData}
                  itemName={'dischargeNote'}
                  isDelBtn={isDelBtn}
                />
              </li>
            )}
          </ul>
        </Fragment>
      )}

      {(gyneExamination?.bmeUterus ||
        gyneExamination?.bmeWkSize ||
        gyneExamination?.fornix ||
        gyneExamination?.cmtPresent ||
        gyneExamination?.cmtAbsent ||
        gyneExamination?.bleedingAbsent ||
        gyneExamination?.bleedingAbsent) && (
        <div className="sub-title">
          <b>Bimanual Examination (B/M/E)</b>
        </div>
      )}
      <ul>
        {gyneExamination?.bmeUterus && (
          <li>
            <span className="text-left pr-5">
              <Title>Uterus:</Title>
              <Value> {gyneExamination?.bmeUterus}</Value>
            </span>
            <CommonDeleteBtn
              action={clearData}
              itemName={'bmeUterus'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {gyneExamination?.bmeWkSize && (
          <li>
            <span className="text-left pr-5">
              <Title>wk Size:</Title>
              <Value> {gyneExamination?.bmeWkSize}</Value>
            </span>
            <CommonDeleteBtn
              action={clearData}
              itemName={'bmeWkSize'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {gyneExamination?.fornix && (
          <li>
            <span className="text-left pr-5">
              <Title>Fornices:</Title>
              <Value> {gyneExamination?.fornix}</Value>
            </span>
            <CommonDeleteBtn
              action={clearData}
              itemName={'fornix'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {gyneExamination?.cmtPresent && (
          <li>
            <span className="text-left pr-5">
              <Title>CMT:</Title>
              <Value> Present</Value>
            </span>
            <CommonDeleteBtn
              action={clearData}
              itemName={'cmtPresent'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {gyneExamination?.cmtAbsent && (
          <li>
            <span className="text-left pr-5">
              <Title>CMT:</Title>
              <Value> Absent</Value>
            </span>
            <CommonDeleteBtn
              action={clearData}
              itemName={'cmtAbsent'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {gyneExamination?.bleedingAbsent && (
          <li>
            <span className="text-left pr-5">
              <Title>Bleeding:</Title>
              <Value> Present</Value>
            </span>
            <CommonDeleteBtn
              action={clearData}
              itemName={'bleedingAbsent'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {gyneExamination?.bleedingPresent && (
          <li>
            <span className="text-left pr-5">
              <Title>Bleeding:</Title>
              <Value> Absent</Value>
            </span>
            <CommonDeleteBtn
              action={clearData}
              itemName={'bleedingPresent'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
      </ul>
      {(gyneExamination?.pawHealthy ||
        gyneExamination?.pawInfected ||
        gyneExamination?.pawNote) && (
        <div className="sub-title">
          <b>Per Abdominal Wound</b>
        </div>
      )}
      <ul>
        {gyneExamination?.pawHealthy && (
          <li>
            <span className="text-left pr-5">
              <Title>Per Abdominal Wound:</Title>
              <Value> Healthy</Value>
            </span>
            <CommonDeleteBtn
              action={clearData}
              itemName={'paw'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {gyneExamination?.pawInfected && (
          <li>
            <span className="text-left pr-5">
              <Title>Per Abdominal Wound::</Title>
              <Value> Infected</Value>
            </span>
            <CommonDeleteBtn
              action={clearData}
              itemName={'paw'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {gyneExamination?.pawNote && (
          <li>
            <span className="text-left pr-5">
              <Title>Note:</Title>
              <Value> {gyneExamination?.pawNote}</Value>
            </span>
            <CommonDeleteBtn
              action={clearData}
              itemName={'pawNote'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
      </ul>
      {/* Breast area */}
      {isExistAnyBreastData(breastExamination) && (
        <div className="sub-title">
          <b>Breast Examination</b>
        </div>
      )}
      {(getData(breastExamination?.lump)?.length > 0 ||
        getData(breastExamination?.lumpPosition)?.length > 0 ||
        breastExamination?.size ||
        breastExamination?.margin?.length > 0 ||
        breastExamination?.consistency?.length > 0 ||
        breastExamination?.localTemperature?.length > 0 ||
        breastExamination?.mobility?.length > 0 ||
        breastExamination?.overlyingSkin?.length > 0) && (
        <div className="pl-2">LUMP:</div>
      )}
      <ul>
        {getData(breastExamination?.lump).length > 0 && (
          <li>
            <span className="text-left pr-5">
              <Title>Breast:</Title>{' '}
              <Value>
                {getData(breastExamination?.lump)?.map((item, key) => {
                  return <span key={key}>{capitalizeFirstLetter(item)} </span>;
                })}
              </Value>
            </span>
            <CommonDeleteBtn
              action={deleteData}
              itemName={'lump'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {getData(breastExamination?.lumpPosition)?.length > 0 && (
          <li>
            <span className="text-left pr-5">
              <Title>Position:</Title>{' '}
              <Value>
                {getData(breastExamination?.lumpPosition)?.map((item, key) => {
                  return (
                    <span key={key}>
                      {`${item.toLocaleUpperCase()}${
                        getData(breastExamination?.lumpPosition).length - 1 !==
                        key
                          ? ', '
                          : ''
                      }`}{' '}
                    </span>
                  );
                })}
              </Value>
            </span>
            <CommonDeleteBtn
              action={deleteData}
              itemName={'lumpPosition'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {breastExamination?.size && (
          <li>
            <span className="text-left pr-5">
              <Title>Size:</Title>{' '}
              <Value>
                {breastExamination?.size +
                  ' ' +
                  breastExamination?.sizeUnit.toLocaleUpperCase()}
              </Value>
            </span>
            <CommonDeleteBtn
              action={deleteData}
              itemName={'size'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {breastExamination?.margin?.length > 0 && (
          <li>
            <Title>Margin:</Title>{' '}
            <Value>
              {breastExamination?.margin?.map((item, key) => {
                return (
                  <span key={key}>
                    {`${item}${
                      breastExamination?.margin.length - 1 === key ? '' : ', '
                    }`}
                  </span>
                );
              })}
            </Value>
            <CommonDeleteBtn
              action={deleteData}
              itemName={'margin'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {breastExamination?.consistency?.length > 0 && (
          <li>
            <Title>Consistency:</Title>{' '}
            <Value>
              {breastExamination?.consistency?.map((item, key) => {
                return (
                  <span key={key}>
                    {`${item}${
                      breastExamination?.consistency.length - 1 === key
                        ? ''
                        : ', '
                    }`}
                  </span>
                );
              })}
            </Value>
            <CommonDeleteBtn
              action={deleteData}
              itemName={'consistency'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {breastExamination?.localTemperature?.length > 0 && (
          <li>
            <Title>Local Temperature:</Title>{' '}
            <Value>
              {breastExamination?.localTemperature?.map((item, key) => {
                return (
                  <span key={key}>
                    {`${item}${
                      breastExamination?.localTemperature.length - 1 === key
                        ? ''
                        : ', '
                    }`}
                  </span>
                );
              })}
            </Value>
            <CommonDeleteBtn
              action={deleteData}
              itemName={'localTemperature'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {breastExamination?.mobility?.length > 0 && (
          <li>
            <Title>Mobility:</Title>{' '}
            <Value>
              {breastExamination?.mobility?.map((item, key) => {
                return (
                  <span key={key}>
                    {`${item}${
                      breastExamination?.mobility.length - 1 === key ? '' : ', '
                    }`}
                  </span>
                );
              })}
            </Value>
            <CommonDeleteBtn
              action={deleteData}
              itemName={'mobility'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {breastExamination?.overlyingSkin?.length > 0 && (
          <li>
            <Title>Overlying Skin:</Title>{' '}
            <Value>
              {breastExamination?.overlyingSkin?.map((item, key) => {
                return (
                  <span key={key}>
                    {`${item}${
                      breastExamination?.overlyingSkin.length - 1 === key
                        ? ''
                        : ', '
                    }`}
                  </span>
                );
              })}
            </Value>
            <CommonDeleteBtn
              action={deleteData}
              itemName={'overlyingSkin'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
      </ul>
      {(getData(breastExamination?.nippleArolaComplex)?.length > 0 ||
        getData(breastExamination?.nippleArolaComplexPosition)?.length > 0 ||
        breastExamination?.nippleOthers?.length > 0) && (
        <div className="pl-2">Nipple Arola Complex:</div>
      )}
      <ul>
        {getData(breastExamination?.nippleArolaComplex)?.length > 0 && (
          <li>
            <span className="text-left pr-5">
              <Title>Breast:</Title>{' '}
              <Value>
                {getData(breastExamination?.nippleArolaComplex)?.map(
                  (item, key) => {
                    return (
                      <span key={key}>{capitalizeFirstLetter(item)} </span>
                    );
                  },
                )}
              </Value>
            </span>
            <CommonDeleteBtn
              action={deleteData}
              itemName={'nippleArolaComplex'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {getData(breastExamination?.nippleArolaComplexPosition)?.length > 0 && (
          <li>
            <span className="text-left pr-5">
              <Title>Clinical Assessment:</Title>{' '}
              <Value>
                {getData(breastExamination?.nippleArolaComplexPosition)?.map(
                  (item, key) => {
                    return (
                      <span key={key}>
                        {`${capitalizeFirstLetter(item)}${
                          getData(breastExamination?.nippleArolaComplexPosition)
                            .length -
                            1 !==
                          key
                            ? ', '
                            : ''
                        }`}{' '}
                      </span>
                    );
                  },
                )}
              </Value>
            </span>
            <CommonDeleteBtn
              action={deleteData}
              itemName={'nippleArolaComplexPosition'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {breastExamination?.nippleOthers?.length > 0 && (
          <li>
            <Title>Others:</Title>{' '}
            <Value>
              {breastExamination?.nippleOthers?.map((item, key) => {
                return (
                  <span key={key}>
                    {`${item}${
                      breastExamination?.nippleOthers.length - 1 === key
                        ? ''
                        : ', '
                    }`}
                  </span>
                );
              })}
            </Value>
            <CommonDeleteBtn
              action={deleteData}
              itemName={'nippleOthers'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
      </ul>
      {(getData(breastExamination?.axillaryLymphNode)?.length > 0 ||
        getData(breastExamination?.axillaryLymphNodePosition)?.length > 0 ||
        breastExamination?.number ||
        breastExamination?.axillaryOthers?.length > 0 ||
        breastExamination?.note ||
        breastExamination?.findings ||
        breastExamination?.isBreastPicture ||
        breastExamination?.showPlusSignBreast) && (
        <div className="pl-2">Axillary Lymph Node:</div>
      )}
      <ul>
        {getData(breastExamination?.axillaryLymphNode)?.length > 0 && (
          <li>
            <span className="text-left pr-5">
              <Title>Breast:</Title>{' '}
              <Value>
                {getData(breastExamination?.axillaryLymphNode)?.map(
                  (item, key) => {
                    return (
                      <span key={key}>{capitalizeFirstLetter(item)} </span>
                    );
                  },
                )}
              </Value>
            </span>
            <CommonDeleteBtn
              action={deleteData}
              itemName={'axillaryLymphNode'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {getData(breastExamination?.axillaryLymphNodePosition)?.length > 0 && (
          <li>
            <span className="text-left pr-5">
              <Title>Clinical Assessment:</Title>{' '}
              <Value>
                {getData(breastExamination?.axillaryLymphNodePosition)?.map(
                  (item, key) => {
                    return (
                      <span key={key}>
                        {`${capitalizeFirstLetter(item)}${
                          getData(breastExamination?.axillaryLymphNodePosition)
                            .length -
                            1 !==
                          key
                            ? ', '
                            : ''
                        }`}{' '}
                      </span>
                    );
                  },
                )}
              </Value>
            </span>
            <CommonDeleteBtn
              action={deleteData}
              itemName={'axillaryLymphNodePosition'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {breastExamination?.number && (
          <li>
            <span className="text-left pr-5">
              <Title>Number:</Title>{' '}
              <Value>
                {breastExamination?.number +
                  ' ' +
                  breastExamination?.numberUnit.toLocaleUpperCase()}
              </Value>
            </span>
            <CommonDeleteBtn
              action={deleteData}
              itemName={'number'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {breastExamination?.axillaryOthers?.length > 0 && (
          <li>
            <Title>Others:</Title>{' '}
            <Value>
              {breastExamination?.axillaryOthers?.map((item, key) => {
                return (
                  <span key={key}>
                    {`${item}${
                      breastExamination?.axillaryOthers.length - 1 === key
                        ? ''
                        : ', '
                    }`}
                  </span>
                );
              })}
            </Value>
            <CommonDeleteBtn
              action={deleteData}
              itemName={'axillaryOthers'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {breastExamination?.note && (
          <li>
            <span className="text-left pr-5">
              <Title>Note:</Title>
              <Value> {breastExamination?.note}</Value>
            </span>
            <CommonDeleteBtn
              action={deleteData}
              itemName={'note'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {breastExamination?.findings && (
          <li>
            <span className="text-left pr-5">
              <Title>Findings:</Title>
              <Value> {breastExamination?.findings}</Value>
            </span>
            <CommonDeleteBtn
              action={deleteData}
              itemName={'findings'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {breastExamination?.isBreastPicture && (
          <li className="breast">
            <Title>Breast:</Title>
            <img src={breastImg} height={140} width={300} />
            <CommonDeleteBtn
              action={deleteData}
              itemName={'isBreastPicture'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {breastExamination?.showPlusSignBreast && (
          <li className="breast">
            <Title>Breast:</Title>
            <img src={plusSignBreastImg} height={110} width={230} />
            <CommonDeleteBtn
              action={deleteData}
              itemName={'showPlusSignBreast'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {others?.lungs && (
          <li>
            <span className="text-left pr-5">
              <Title>Lungs:</Title>
              <Value> {others?.lungs}</Value>
            </span>
            <CommonDeleteBtn
              action={clearOthers}
              itemName={'lungs'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {others?.heart && (
          <li>
            <span className="text-left pr-5">
              <Title>Heart:</Title>
              <Value> {others?.heart}</Value>
            </span>
            <CommonDeleteBtn
              action={clearOthers}
              itemName={'heart'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {others?.thyroidGland && (
          <li>
            <span className="text-left pr-5">
              <Title>Thyroid Gland:</Title>
              <Value> {others?.thyroidGland}</Value>
            </span>
            <CommonDeleteBtn
              action={clearOthers}
              itemName={'thyroidGland'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {others?.breast && (
          <li>
            <span className="text-left pr-5">
              <Title>Breast:</Title>
              <Value> {others?.breast}</Value>
            </span>
            <CommonDeleteBtn
              action={clearOthers}
              itemName={'breast'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {others?.isUrinaryBladderInMale && (
          <li className="breast pb-1">
            <Title>Urinary Bladder In Males:</Title>
            <img src={urinaryBladderInMalesImg} height={80} width={70} />
            <span></span>
            <CommonDeleteBtn
              action={clearOthers}
              itemName={'isUrinaryBladderInMale'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {others?.isOvary && (
          <li className="breast pb-1">
            <Title>Ovary:</Title>
            <img src={ovaryImg} height={80} width={70} />
            <CommonDeleteBtn
              action={clearOthers}
              itemName={'isOvary'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {others?.isHumanUrinaryBladder && (
          <li className="breast">
            <Title>Human Urinary Bladder:</Title>
            <img src={humanUrinaryBladderImg} height={80} width={70} />
            <span></span>
            <CommonDeleteBtn
              action={clearOthers}
              itemName={'isHumanUrinaryBladder'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
      </ul>
    </div>
  );
};

export default memo(Gyne);
